/**
 * @deprecated This should not be used. Use [QuestionType] with capitalized entries at least
 */
export enum CollectionItemType {
  Undefined = 0,
  EitherOr = 1,
  MultipleChoice = 2,
  MultipleResponse = 3,
  ShortAnswer = 4,
  Essay = 5,
  Numeric = 6,
  Match = 9,
  Order = 10,
  Hotspot = 11,
  FileResponse = 12,
  FillInTheBlankText = 14,
  FillInTheBlankGap = 15,     /* Not use it. Maybe future question. Drag and drop. */
  Equation = 16,
  SelectFromTheList = 17,
  Sowiso = 18,
  Section = 19,
  AssessmentPage = 22,
  ExtendedMatch = 20,
  DragAndDrop = 21,
  Programming = 23,
  FinancialStatement = 24,
  ExtendedMultipleChoice = 25,
  ComprehensiveIntegratedPuzzle = 26,
}
